import { InventoryAdjustment } from '@givebacks/api/store';
import { DateTime } from 'luxon';

import { columnsCreator } from '../../../../../utils/csv/csv';

const exportColumnsCreator = columnsCreator<InventoryAdjustment>();

const inventoryAdjustmentsExportColumns = [
  exportColumnsCreator.create({
    header: 'Date',
    cell: (row) => {
      const date = DateTime.fromJSDate(new Date(row.updated_at));

      const formattedDate = date.toFormat('MM/dd/yyyy');
      const formattedTime = date.toFormat('h:mm a');

      return `${formattedDate} at ${formattedTime}`;
    },
  }),
  exportColumnsCreator.create({
    header: 'Adjusted By',
    cell: (row) => {
      const user = row.user;

      return user?.email ?? '--';
    },
  }),
  exportColumnsCreator.create({
    header: 'Type',
    cell: (row) => {
      const type = row.made_by_type;

      return type === 'User' ? 'Manual' : 'Purchase';
    },
  }),
  exportColumnsCreator.create({
    header: 'Increment',
    cell: (row) => {
      return row.amount;
    },
  }),
];

export { inventoryAdjustmentsExportColumns };
